import axios, { AxiosError } from "axios";
import { ApiResponse } from "../../types/BaseModals/ApiResponse";
import { API_URL } from "../../constants/API_URL";
import { OdevlerimError } from "../../types/ErrorModals/OdevlerimError";
import { OdevlerimRequestModal } from "../../types/RequestModals/OdevlerimRequestModal";
import { OdevlerimResponseModal } from "../../types/modals";

export const getOdevlerim = async (
  request: OdevlerimRequestModal
): Promise<OdevlerimResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<OdevlerimResponseModal[]>>(
      `${API_URL}/api/Odevlerim/getOdevlerim`,
      request
    );

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;

      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Ödev bulunamadı",
          correlationId: responseData?.correlationId,
        } as OdevlerimError;
      }

      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId,
        } as OdevlerimError;
      }

      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as OdevlerimError;
    }

    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as OdevlerimError;
  }
};
